import React from 'react';
export function BuiltInCAMSection() {
  return <section data-id="element-2846">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-2847">
        <h2 className="text-2xl md:text-3xl font-bold text-white text-center" data-id="element-2848">
          Built-In CAM Applications
        </h2>
      </div>
      <div className="bg-white p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-2849">
        <div className="grid md:grid-cols-3 gap-8 items-start" data-id="element-2850">
          <div className="md:col-span-2 space-y-8 text-gray-700 text-lg leading-relaxed" data-id="element-2851">
            <p data-id="element-2852">
              Machining technology has been advancing with the development of
              faster, more powerful machines. In order to keep up, many CAM
              applications have developed built-in features for HEM toolpaths,
              including Trochoidal Milling, a method of machining used to create
              a slot wider than the cutting tool's cutting diameter.
            </p>

            <div className="bg-gray-50 p-6 rounded-lg border border-gray-200 text-center space-y-4" data-id="element-2853">
              <div className="aspect-video w-full max-w-2xl mx-auto rounded-lg overflow-hidden shadow-sm" data-id="element-2854">
                <iframe className="w-full h-full" src="https://www.youtube-nocookie.com/embed/S-DB2Vmr0qw?wmode=opaque" title="High Efficiency Milling Strategy - Trochoidal Machining" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-2855"></iframe>
              </div>
              <p className="font-bold text-navy" data-id="element-2856">
                High Efficiency Milling Strategy - Trochoidal Machining
              </p>
            </div>

            <p data-id="element-2857">
              HEM is largely based on the theory surrounding Radial Chip
              Thinning, or the phenomenon that occurs with varying RDOC, and
              relates to the chip thickness and feed per tooth. HEM adjusts
              parameters to maintain a constant load on the tool through the
              entire roughing operation, resulting in more aggressive material
              removal rates (MRR). In this way, HEM differs from other high
              performance toolpaths, which involve different methods for
              achieving significant MRR.
            </p>

            <div className="text-center py-4" data-id="element-2858">
              <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/HSM/Radial%20Chip%20Thinning.png800x800.png" alt="Radial Chip Thinning" className="mx-auto max-w-xl w-full h-auto rounded-lg shadow-sm border border-gray-200 block" data-id="element-2859" />
            </div>

            <p data-id="element-2860">
              Virtually any CNC machine can perform HEM – the key is a fast CNC
              controller. When converting from a regular program to HEM, about
              20 lines of HEM code will be written for every line of regular
              code. A fast processor is needed to look ahead for the code, and
              keep up with the operation. In addition, advanced CAM software
              that intelligently manages tool load by adjusting the IPT and RDOC
              is also needed.
            </p>
          </div>

          <div className="md:col-span-1 bg-gray-50 p-6 rounded-lg border border-gray-200 text-center" data-id="element-2861">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.peakedm.com/uploaded/images/Mikron/MILL%20E/Heidenhain%20TNC%20640%20and%20Smart%20Machine.png" alt="Heidenhain TNC 640 and Smart Machine" className="mx-auto h-auto max-w-full rounded-lg block" data-id="element-2862" />
          </div>
        </div>
      </div>
    </section>;
}